import { render, staticRenderFns } from "./Meeting.Layout.Lecturer.Row.vue?vue&type=template&id=b995ee06&scoped=true"
import script from "./Meeting.Layout.Lecturer.Row.vue?vue&type=script&lang=js"
export * from "./Meeting.Layout.Lecturer.Row.vue?vue&type=script&lang=js"
import style0 from "./Meeting.Layout.Lecturer.Row.vue?vue&type=style&index=0&id=b995ee06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b995ee06",
  null
  
)

export default component.exports